<ng-container *transloco="let t; read: 'target-editor'">
  <div class="worker-permissions">
    <span class="font-bold">{{ t('workerPermissionsTitle') }}</span>
    <p-selectButton [formControl]="join" [options]="workerPermissionsOptions">
      <ng-template let-item pTemplate="item">{{ t(item.label) }}</ng-template>
    </p-selectButton>

    <app-form-field-help [control]="join">
      <ng-container *ngIf="isPermissionSelected" form-field-help-hint>
        {{ t(join.value ? 'workerPermissionsUserHelpText' : 'workerPermissionsAdminHelpText') }}
      </ng-container>
    </app-form-field-help>
  </div>
</ng-container>
